<script>
import {useStore} from "vuex";
import {ref, watch} from "vue";
import $ from "jquery";
import router from "@/router";
import Swals from "@/assets/js/Swals";
import FreeWorld from "@/assets/js/FreeWorld";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import VideoPage from "@/components/assetComponents/VideoPage.vue";

export default {
  name: "CartPage",
  components: {VideoPage, LoadingPage},

  setup() {

    let store = useStore()
    let orders = ref(store.state.order)

    let loading = ref(false)
    let video_play = ref(false)
    let video_src = ref(store.state.info.video_factor)

    let div_factor = ref(false)
    let factor = ref(store.state.order.factor)
    if (store.state.profile.codeid === null || store.state.profile.codepost === null) {factor.value = false ; store.commit('set_factor' , factor.value)}

    watch(orders.value.products, () => {
      if (orders.value.products.length === 0) {
        store.commit('EmptyBasket');
        router.push({name: 'HomePage'})
      }
    })
    if (orders.value.products.length === 0) {
      store.commit('EmptyBasket');
      router.push({name: 'HomePage'})
    }else {
      check_factor()
    }

    function check_factor(type) {
      if (type){
        if (store.state.profile.codeid === null || store.state.profile.codepost === null){
          Swals.Warning('دوست عزیز، جهت صدور فاکتور رسمی کد ملی و کد پستی خودت را در پروفایل تکمیل کن')
          factor.value = false
          video_play.value = true
        }else {
        store.commit('set_factor' , factor.value)
        }
        return false
      }


      let data = {
        action:'factor',
        pids: null,
        sid: orders.value.products[0].shop.id
      }
      data.pids = orders.value.products.map(item => item.pid)

      loading.value = true
      FreeWorld.Heisenberg(data, 'info').then((res) => {

        loading.value = false
        div_factor.value = res.data.factor

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, check_factor)
      })

    }

    function update_orders(item, action) {

      switch (action){
        case 'delete':
          $("#order" + item.pid).removeClass('animate__fadeInRight').addClass('animate__fadeOutRight')
          setTimeout(() => {
            item.shop.number = 0
            store.commit('ProductUpdate', item)
          }, 500)
          return false

        case 'close':
          Swals.Question('آیا از حذف سبد خرید خود اطمینان دارید؟', 'حذف سبد خرید').then((res) => {
            if (res.isConfirmed) {
              store.commit('EmptyBasket')
              Swals.Done('سبد خرید شما با موفقیت حذف شد', 'HomePage')
            }
          })
          return false
      }


      if (item.shop.number === 0) {
        $("#order" + item.pid).removeClass('animate__fadeInRight').addClass('animate__fadeOutRight')
        setTimeout(() => {
          store.commit('ProductUpdate', item)
        }, 500)
      } else {
        store.commit('ProductUpdate', item)
      }

    }


    return {

      orders,
      update_orders,
      factor,
      div_factor,
      loading,
      check_factor,
      video_play,
      video_src,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div v-if="video_play" @click="video_play = false" class="bg_dialog"></div>


  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow d-flex align-items-center justify-content-between shadow-custom bg-white">
      <div @click="update_orders({} , 'close')" class="d-flex align-items-center">
        <p class="font-4 font-color">انصراف</p>
        <img src="../assets/img/closing_color.svg" alt="" class="svg-arrow">
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">مشاهده سبد خرید</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="p-body mt-3">


      <div class="bg-white rounded-4 shadow-custom mb-5 overflow-hidden">

        <div class="d-flex align-items-center justify-content-between mb-3">

          <div class="d-flex w-30 p-2 flex-column align-items-center rounded-top-4 shadow_select">
            <img class="icons icon_shadow mb-2" src="../assets/img/icon_buyBox.svg" alt="">
            <p class="font-4 font-color">سبد خرید</p>
          </div>
          <div class="d-flex w-30 p-2 flex-column align-items-center">
            <img class="icons icon_shadow mb-2" src="../assets/img/gps_light.svg" alt="">
            <p class="font-5 font-color_light">اطلاعات ارسال</p>
          </div>
          <div class="d-flex w-30 p-2 flex-column align-items-center">
            <img class="icons icon_shadow mb-2" src="../assets/img/card-payment-light.svg" alt="">
            <p class="font-5 font-color_light">اطلاعات پرداخت</p>
          </div>

        </div>


        <div class="p-body">

          <div class="list_products">
            <div v-for="item in orders.products" :key="item.pid" :id="'order' + item.pid"
                 class="animate__animated animate__fadeInRight text-decoration-none rounded-4 bg-color-blue-light p-2 mb-3 shadow-custom">

              <div class="d-flex justify-content-between ">
                <div class="animated-background prod_img rounded-4">
                  <img class="w-100 h-100 rounded-4" :src="item.pic" alt="">
                </div>

                <div class="position-relative d-flex flex-column justify-content-evenly mr-2 w-65">
                  <img @click="update_orders(item , 'delete')" class="icon_closing position-absolute"
                       src="../assets/img/closing_white.svg" alt="">

                  <div class="overflow-hidden w-85 mb-2">
                    <p class="font-color font-4 font-bold" :class="{'txtoverflow': item.name.length > 25}">{{ item.name }}</p>
                  </div>

                  <div class="d-flex align-items-center justify-content-between">
                    <div class="">
                      <p v-if="item.shop.price !== item.shop.price_show" class="font-5 font-color text-decoration-line-through">{{ item.shop.price.toLocaleString() }} تومان</p>
                      <p class="font-5 font-color font-bold">{{ item.shop.price_show.toLocaleString() }} تومان</p>
                    </div>

                    <div
                        class="div_mojodi shadow-custom w-45 d-flex align-items-center justify-content-between p-1 rounded-pill">
                      <img v-if="orders.offer !== null" src="../assets/img/plus_disabel.svg" alt="" class="icon_plus icon_shadow">
                      <img v-else @click="item.shop.number++; update_orders(item)" src="../assets/img/icon_plus.svg" alt="" class="icon_plus icon_shadow">
                      <p class="font-4 font-bold">{{ item.shop.number }}</p>
                      <img v-if="orders.offer !== null" src="../assets/img/min_disabel.svg" alt="" class="icon_plus icon_shadow">
                      <img v-else @click="item.shop.number--; update_orders(item)" src="../assets/img/icon_min.svg" alt="" class="icon_plus icon_shadow">
                    </div>

                  </div>

                </div>
              </div>

            </div>
          </div>

          <div v-if="orders.products.length > 0" class="bg-color-blue-light rounded-3 shadow-custom mb-4 p-2">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center w-55">
                <img style="width: 20px" src="../assets/img/store_color.svg" alt="" class="ml-2">

                <div class="overflow-hidden d-flex align-items-center">
                  <p class="font-4 font-color" :class="{'txtoverflow': orders.products[0].shop.shopname.length > 17}">
                    {{ orders.products[0].shop.shopname }}</p>
                </div>
              </div>

              <router-link :to="{name:'StorePage',params:{sid:orders.products[0].shop.id,shopname:orders.products[0].shop.shopname}}" class="text-decoration-none text-center w-45 p-2 bg-white font-6 font-color rounded-pill shadow-custom">مشاهده محصولات فروشگاه</router-link>
            </div>
          </div>

          <div v-if="div_factor" class="animate__animated animate__fadeInRight shadow-custom rounded-3 p-2 d-flex align-items-center mb-4">
            <input v-model="factor" @change="check_factor('set')" class="ml-2" id="factor" type="checkbox">
            <label class="font-4 font-color" for="factor">ارائه فاکتور رسمی توسط فروشنده</label>
          </div>

          <div class="bg-color-blue-light rounded-4 p-3 mb-3">
            <p class="font-color font-3 font-bold text-center">جزئیات پرداخت</p>

            <div class="div_hr my-2"></div>
            <div class="d-flex align-items-center justify-content-between p-2">
              <p class="font-4">تعداد اقلام</p>
              <p class="font-4">{{ orders.orders_count }}</p>
            </div>

            <div class="div_hr my-2"></div>
            <div class="d-flex align-items-center justify-content-between p-2">
              <p class="font-4">جمع کل قبل از تخفیف</p>
              <p class="font-4 d-flex">
                <span class="">{{ orders.orders_all_price.toLocaleString() }}</span>
                <span class="mr-1">تومان</span>
              </p>
            </div>

            <div class="div_hr my-2"></div>
            <div class="d-flex align-items-center justify-content-between p-2">
              <p class="font-4">سود شما از این خرید</p>
              <p class="font-4 d-flex">
                <span class="">{{ orders.orders_profit.toLocaleString() }}</span>
                <span class="mr-1">تومان</span>
              </p>
            </div>

            <div class="div_hr my-2"></div>
            <div class="d-flex bg-white rounded-3 align-items-center justify-content-between px-2 py-3">
              <p class="font-4">مبلغ قابل پرداخت</p>
              <p class="font-4 font-bold font-color-green d-flex">
                <span class="">{{ orders.orders_price.toLocaleString() }}</span>
                <span class="mr-1">تومان</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <VideoPage v-if="video_play" :src="video_src"></VideoPage>

      <router-link :to="{name:'CartInfoSend'}" class="text-decoration-none d-flex justify-content-center mb-3">
        <v-btn class="bg-color h-100 rounded-4 p-3 font-4 shadow-custom text-white w-90">تایید و ادامه سبد خرید</v-btn>
      </router-link>

    </div>


  </div>

</template>


<style scoped>

.icons {
  width: 2rem;
  height: 2rem;
}
.shadow_select {
box-shadow: 0 -10px 15px -2px #707070;
}

@media (min-width: 700px) {
  .prod_img {
    height: 10rem !important;
  }
}
@media (min-width: 1000px) {
  .prod_img {
    width: 30%!important;
    height: 14rem !important;
  }
}
.prod_img {
  width: 35%;
  height: 8rem;
}
.icon_closing {
  width: 2rem;
  height: 2rem;
  left: 0;
  top: 0;
}
.icon_plus {
  width: 2rem;
  height: 2rem;
}
.div_mojodi {
  border: 1px solid #00F593;
}
.div_hr {
  width: 100%;
  height: 1px;
  border: rgba(43, 48, 53, 0.47) dashed 1px;
}

</style>